$(window).on('load', function() {
  "use strict";
  $('.megamenu-li').parent('.container').parent('ul').addClass('mega-menu');
  $('.banner-wrap').parent('.container').parent('ul').addClass('bottom-banner');
  $('.menu-banner').parent('.container').parent('ul').addClass('banner-menu');
  $('.submenu-li').parent('.container').parent('ul').addClass('sub-menu');

  $('.submenu-li').parent('ul').addClass('sub-menu');
  $('.megamenu-li').parent('ul').addClass('mega-menu');
  $('.bannermenu-li').parent('ul').addClass('banner-menu');

  $('.slow-window').fadeOut('slow');

  var popup = localStorage.getItem('popup_value'); 
  if(popup != 1){
    $('#news-letter-modal').modal('show');
  }

  $('#popup-close').on('click',function(){
      localStorage.setItem('popup_value', '1');
  });
  $("button.navbar-toggle").on('click', function() {
    $(".main-menu-area").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden");
  });

  $(".close-box").on('click', function() {
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  });

  $(".shopping-cart a.cart-count").on('click', function() {
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
  });

  $(".shopping-cart-close i").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
     $("body").removeClass("hidden");
  });

   $(".ajax-spin-cart").on('click', function() {
    window.setTimeout(function() {
      $(".mini-cart").addClass("show");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    }, 1000);
  });

  // filter button js
  $("button.filter-button").on('click', function() {
    $(".filter-sidebar").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
  });

  $("button.close-filter-sidebar").on('click', function() {
    $(".filter-sidebar").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
  });

  $(".mm-fullscreen-bg").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $(".filter-sidebar").removeClass("active");
    $("body").removeClass("hidden");
  });

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });

  $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
    tClose: 'Close (Esc)',
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

      
  $('#top').on('click', function() {
    $("html, body").animate({ scrollTop: 0 }, 0);
    return false;
    });
  });

$(window).scroll(function(){
  if ($(this).scrollTop() > 1000) {
    $('#top').fadeIn();
  } else {
    $('#top').fadeOut();
  }

  var sticky = $('.header-area'),
  scroll = $(window).scrollTop();
  if (scroll >= 150) {
    sticky.addClass('is-sticky');
  }
  else {
    sticky.removeClass('is-sticky');
  }
  
});

// Remove breadcrum from pages 
document.addEventListener("DOMContentLoaded", function () {
  const pages = [
    "/collections/privacy-screen-protectors",
    "/collections/hd-screen-protectors",
    "/pages/contact",
    "/collections/all",
    "/pages/our-core-goals"
  ];

  if (pages.includes(window.location.pathname)) {
    document.querySelectorAll(".breadcrumb-area").forEach(function (breadcrumb) {
      breadcrumb.remove();
    });
  }
});

// hide breadcrumb in wishlist page 
if (window.location.pathname.replace(/\/$/, '') === '/apps/wishlist' || window.location.pathname.replace(/\/$/, '') === '/cart') {

  const hideBreadcrumb = () => {
    const breadcrumb = document.querySelector('.breadcrumb-area');

    if (breadcrumb) {
      breadcrumb.style.setProperty('display', 'none', 'important');
      return true;
    }

    return false;
  };

  if (!hideBreadcrumb()) {
    const observer = new MutationObserver(() => {
      if (hideBreadcrumb()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

// contact us page customization
(function () {
  function fixContactMain() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/contact') return;

    var main = document.querySelector('main[role="main"]');

    if (main) {
      main.style.cssText += `
        display: flex !important;
        width: 100% !important;
        max-width: 1400px !important;
        margin-left: auto !important;
        margin-right: auto !important;
        justify-content: initial !important;
        align-items: initial !important;
      `;
    }
  }

  fixContactMain();

  window.addEventListener('load', fixContactMain);

  setTimeout(fixContactMain, 500);
  setTimeout(fixContactMain, 1000);
  setTimeout(fixContactMain, 2000);
})();

setInterval(() => {
  if (location.pathname.includes('/pages/contact')) {
    const m = document.querySelector('main[role="main"]');

    if (m) {
      
      if (window.innerWidth <= 767) {
        m.style.setProperty('display', 'block', 'important');
        m.style.setProperty('max-width', '100%', 'important');
        m.style.setProperty('width', '100%', 'important');
        m.style.setProperty('margin', '0', 'important');
      }
    }
  }
}, 200);

setInterval(() => {
  if (location.pathname.includes('/pages/contact')) {
    const form = document.querySelector('.contact-form-list #contact_form');

    if (form && !form.nextElementSibling?.classList.contains('contact-note')) {
      const p = document.createElement('p');
      p.className = 'contact-note';
      p.textContent = 'Our team will respond to your inquiry promptly.';
      form.after(p);
    }
  }
}, 200);

// catalog mobile menu script 
document.addEventListener('click', function(e) {

  if (window.innerWidth > 749) return;

  const link = e.target.closest(
    '.catalog-menu-link, .catalog-submenu-link'
  );

  if (!link) return;

  const item = link.parentElement;
  const submenu = item.querySelector(
    ':scope > .catalog-submenu, :scope > .catalog-third-menu'
  );

  if (!submenu) return;

  e.preventDefault();
  e.stopPropagation();

  item.classList.toggle('open');

});

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('#popular-products-popular_products_Fd3j3h');
  if (!section) return;

  const slider = section.querySelector('.popular-products__slider-wrap');
  const grid = section.querySelector('#pp-grid-popular_products_Fd3j3h');
  const prev = section.querySelector('.pp-prev');
  const next = section.querySelector('.pp-next');

  if (!slider || !grid || !prev || !next) return;

  function updateButtons() {
    const maxScroll = grid.scrollWidth - slider.clientWidth;
    const currentScroll = Math.abs(
      parseFloat(grid.style.transform.replace(/[^-\d.]/g, '')) || 0
    );

    prev.classList.toggle('is-disabled', currentScroll <= 1);
    next.classList.toggle('is-disabled', currentScroll >= maxScroll - 1);
  }

  prev.addEventListener('click', function () {
    if (prev.classList.contains('is-disabled')) return;

    const amount = slider.clientWidth;
    const current = Math.abs(
      parseFloat(grid.style.transform.replace(/[^-\d.]/g, '')) || 0
    );

    const newPosition = Math.max(0, current - amount);

    grid.style.transform = `translateX(-${newPosition}px)`;
    updateButtons();
  });

  next.addEventListener('click', function () {
    if (next.classList.contains('is-disabled')) return;

    const amount = slider.clientWidth;
    const maxScroll = grid.scrollWidth - slider.clientWidth;
    const current = Math.abs(
      parseFloat(grid.style.transform.replace(/[^-\d.]/g, '')) || 0
    );

    const newPosition = Math.min(maxScroll, current + amount);

    grid.style.transform = `translateX(-${newPosition}px)`;
    updateButtons();
  });

  updateButtons();
  window.addEventListener('resize', updateButtons);
});

// Add to Cart should not redirect to cart page 
document.addEventListener('submit', async function (e) {
  const form = e.target.closest('.product-card-add-to-cart');
  if (!form) return;

  e.preventDefault();

  const button = form.querySelector('.product-card-add-btn');
  const productId = form.querySelector('input[name="id"]').value;

  button.disabled = true;
  button.textContent = 'Adding...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(productId),
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Failed to add product');

    await response.json();

    button.textContent = 'Added ✓';

    // Update cart count if your theme has one
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    document.querySelectorAll('[data-cart-count], .cart-count, .cart__count').forEach(el => {
      el.textContent = cart.item_count;
    });

    setTimeout(() => {
      button.textContent = 'Add to Cart';
      button.disabled = false;
    }, 1500);

  } catch (error) {
    console.error('Add to cart error:', error);
    button.textContent = 'Try Again';
    button.disabled = false;
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const tabNav = document.querySelector('.tab-nav');
  const tabContent = document.querySelector('.tab-wrap');

  if (!tabNav || !tabContent) return;

  const tabs = tabNav.querySelectorAll('.tab-nav-item');
  const panels = tabContent.querySelectorAll('.tab-wrapper');

  // Remove active class from all tabs and panels
  tabs.forEach(tab => tab.classList.remove('active'));
  panels.forEach(panel => panel.classList.remove('active'));

  // Activate the first tab
  const firstTab = tabs[0];

  if (firstTab) {
    firstTab.classList.add('active');

    // Find the matching content panel
    const targetId = firstTab.getAttribute('data-tab-target');
    const targetPanel = document.getElementById(targetId);

    if (targetPanel) {
      targetPanel.classList.add('active');
    }
  }
});